import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import {FormattedMessage} from 'react-intl';

import {Icon, Heading} from '@stubhub/bamboo';
import {FAN_PROTECT_LINKS} from '@stubhub/general-utils';
import FormattedLink from '@stubhub/react-formatted-link';

import '../styles/index.scss';

const StrongChunk = (chunks) => <strong>{chunks}</strong>;

const Guarantee = ({className, onClick, showBorder = true}, {globalRegistry}) => {
  const locale = globalRegistry?.getCurrentLocale()?.toLowerCase();
  const fan_protect_url = FAN_PROTECT_LINKS[locale] || FAN_PROTECT_LINKS.default;

  return (
    <div
      className={cs(className, 'guarantee-card', {
        'guarantee-card--with-border': showBorder,
      })}
    >
      <div className="guarantee-card__title">
        <Icon name="FanProtect" />
        <Heading tag="h4" className="guarantee-card__heading">
          <FormattedLink href={fan_protect_url} onClick={onClick}>
            <FormattedMessage id="guarantee.title" defaultMessage="100% guarantee" />
          </FormattedLink>
        </Heading>
      </div>
      <ul>
        <li>
          <FormattedMessage
            id="guarantee.back_order"
            defaultMessage="<strong>We back every order</strong>"
            values={{strong: StrongChunk}}
          />
        </li>
        <li>
          <FormattedMessage
            id="guarantee.tickets_original"
            defaultMessage="<strong>Tickets are original</strong> and will arrive in time for the event"
            values={{strong: StrongChunk}}
          />
        </li>
        <li>
          <FormattedMessage
            id="guarantee.refund"
            defaultMessage="<strong>Full refund if the event is cancelled</strong> and not rescheduled"
            values={{strong: StrongChunk}}
          />
        </li>
        <li>
          <FormattedMessage
            id="guarantee.customer_service"
            defaultMessage="<strong>Customer service all the way</strong> out to your seat"
            values={{strong: StrongChunk}}
          />
        </li>
      </ul>
    </div>
  );
};

Guarantee.contextTypes = {
  globalRegistry: PropTypes.object,
};

Guarantee.propTypes = {
  /* Custom classname for the container */
  className: PropTypes.string,

  /* Callback invoked when guarantee link is clicked */
  onClick: PropTypes.func,

  /** If border is shown */
  showBorder: PropTypes.bool,
};

export default Guarantee;
